let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("8KQmP")).then(() => parcelRequire('ejLY3'));